import { useState } from "react";
import { CountriesHeaderV2 } from "./CountriesHeaderV2";

export const CountriesPage = () => {
    const [selectedCountry, setSelectedCountry] = useState('All');
    
    return (
        <div>
            <CountriesHeaderV2 selectedCountry={selectedCountry} setSelectedCountry={setSelectedCountry} />
            
        </div>
    );
}